/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mobile_App_Development_Harden_Detail6Inputs */

const en_svc_mobile_app_development_harden_detail6 = /** @type {(inputs: Svc_Mobile_App_Development_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Store submission, review process, crash monitoring, launch support.`)
};

const ar_svc_mobile_app_development_harden_detail6 = /** @type {(inputs: Svc_Mobile_App_Development_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تقديم المتجر وعملية المراجعة ومراقبة الأعطال ودعم الإطلاق.`)
};

const bn_svc_mobile_app_development_harden_detail6 = /** @type {(inputs: Svc_Mobile_App_Development_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`স্টোর সাবমিশন, রিভিউ প্রসেস, ক্র্যাশ মনিটরিং, লঞ্চ সাপোর্ট।`)
};

const de_svc_mobile_app_development_harden_detail6 = /** @type {(inputs: Svc_Mobile_App_Development_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Store-Einreichung, Überprüfungsprozess, Absturzüberwachung, Startunterstützung.`)
};

const es_svc_mobile_app_development_harden_detail6 = /** @type {(inputs: Svc_Mobile_App_Development_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicación en tienda, proceso de revisión, monitoreo de fallos, soporte de lanzamiento.`)
};

const fr_svc_mobile_app_development_harden_detail6 = /** @type {(inputs: Svc_Mobile_App_Development_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publication sur le store, processus de review, surveillance des plantages, aide au lancement.`)
};

const pt_svc_mobile_app_development_harden_detail6 = /** @type {(inputs: Svc_Mobile_App_Development_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicação na loja, processo de revisão, monitoramento de falhas, suporte de lançamento.`)
};

const zh_svc_mobile_app_development_harden_detail6 = /** @type {(inputs: Svc_Mobile_App_Development_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`商店提交、审核流程、崩溃监控、启动支持。`)
};

const tr_svc_mobile_app_development_harden_detail6 = /** @type {(inputs: Svc_Mobile_App_Development_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mağaza başvurusu, inceleme süreci, crash izleme, lansman desteği.`)
};

const ru_svc_mobile_app_development_harden_detail6 = /** @type {(inputs: Svc_Mobile_App_Development_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подача в стор, процесс ревью, мониторинг крашей, поддержка запуска.`)
};

const pl_svc_mobile_app_development_harden_detail6 = /** @type {(inputs: Svc_Mobile_App_Development_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zgłoszenie do sklepu, proces review, monitoring crashy, wsparcie startu.`)
};

/**
* | output |
* | --- |
* | "Store submission, review process, crash monitoring, launch support." |
*
* @param {Svc_Mobile_App_Development_Harden_Detail6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mobile_app_development_harden_detail6 = /** @type {((inputs?: Svc_Mobile_App_Development_Harden_Detail6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mobile_App_Development_Harden_Detail6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mobile_app_development_harden_detail6(inputs)
	if (locale === "bn") return bn_svc_mobile_app_development_harden_detail6(inputs)
	if (locale === "de") return de_svc_mobile_app_development_harden_detail6(inputs)
	if (locale === "es") return es_svc_mobile_app_development_harden_detail6(inputs)
	if (locale === "fr") return fr_svc_mobile_app_development_harden_detail6(inputs)
	if (locale === "pt") return pt_svc_mobile_app_development_harden_detail6(inputs)
	if (locale === "zh") return zh_svc_mobile_app_development_harden_detail6(inputs)
	if (locale === "tr") return tr_svc_mobile_app_development_harden_detail6(inputs)
	if (locale === "ru") return ru_svc_mobile_app_development_harden_detail6(inputs)
	if (locale === "pl") return pl_svc_mobile_app_development_harden_detail6(inputs)
	return en_svc_mobile_app_development_harden_detail6(inputs)
});
export { svc_mobile_app_development_harden_detail6 as "svc_mobile-app-development_HARDEN_detail" }